import { useSelector } from 'react-redux';

export function useSidepanelWallpaper() {
    return useSelector((state) => state.ui.sidePanel.wallpaper);
}
